import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import {
  FaCircleQuestion,
  FaWallet,
  FaTicket,
  FaIndianRupeeSign,
  FaUserSlash,
  FaUserPlus,
  FaHandshake,
  FaFileCircleQuestion,
  FaMagnifyingGlass,
} from "react-icons/fa6";

// 👉 abhi static, baad me API se FAQ categories aayengi
const faqCategories = [
  { id: 1, icon: <FaCircleQuestion />, title: "How [Site] Works?", topic: "how-it-works" },
  { id: 2, icon: <FaWallet />, title: "Your Cashback or Rewards", topic: "cashback-rewards" },
  { id: 3, icon: <FaTicket />, title: "Missing Cashback or Rewards", topic: "missing-cashback" },
  { id: 4, icon: <FaIndianRupeeSign />, title: "Payment Related", topic: "payment" },
  { id: 5, icon: <FaUserSlash />, title: "Unable to Login?", topic: "login-issue" },
  { id: 6, icon: <FaUserPlus />, title: "Refer & Earn", topic: "refer-earn" },
  { id: 7, icon: <FaHandshake />, title: "Partner with Us", topic: "want-to-partner" },
  { id: 8, icon: <FaFileCircleQuestion />, title: "Other Queries", topic: "other-questions" },
];

const FAQ = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  const filteredFaqs = faqCategories.filter((f) =>
    f.title.toLowerCase().includes(search.toLowerCase())
  );

  const handleFaqClick = (topic) => {
    // 👉 Baad me yaha ya to FAQ detail page khulega, ya contact form
    navigate(`/help/contact-us?topic=${topic}`);
  };

  return (
    <>
      <nav className="faq-breadcrumb">
        <div className="container">
          <span onClick={() => navigate("/")}>Home</span> /{" "}
          <span onClick={() => navigate("/help")}>Get Help</span> /{" "}
          <b>Frequently Asked Questions</b>
        </div>
      </nav>

      <section className="faq-section">
        <div className="container">
          <div className="faq-search-wrap">
            <input
              type="text"
              placeholder="What are you looking for?"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          <span className="faq-search-icon">
  <FaMagnifyingGlass/>
</span>
          </div>

          <div className="faq-grid">
            {filteredFaqs.map((f) => (
              <div
                key={f.id}
                className="faq-card"
                onClick={() => handleFaqClick(f.topic)}
              >
                <div className="faq-card-icon">{f.icon}</div>
                <p>{f.title}</p>
              </div>
            ))}
          </div>

          {filteredFaqs.length === 0 && (
            <p className="faq-no-result">Koi result nahi mila.</p>
          )}
        </div>
      </section>

      <Footer />

      <style jsx>{`
        .faq-breadcrumb {
          padding: 12px 0;
          font-size: 0.9rem;
          color: #555;
        }
        .faq-breadcrumb span {
          cursor: pointer;
           color: var(--primary);
        }
        .faq-section {
          padding: 2rem 0 4rem;
        }
        .faq-search-wrap {
          position: relative;
          max-width: 500px;
          margin: 0 auto 2.5rem;
        }
        .faq-search-wrap input {
          width: 100%;
          padding: 0.8rem 2.5rem 0.8rem 1rem;
          border: 1px solid #ddd;
          border-radius: 8px;
          font-size: 0.95rem;
        }
        .faq-search-icon {
          position: absolute;
          right: 14px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
        }
        .faq-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 1.5rem;
        }
        .faq-card {
          display: flex;
          flex-direction: column;
          justify-content: center;
          min-height: 160px;
          width: 100%;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 1.8rem 1.6rem;
          text-align: left;
          cursor: pointer;
          background: #fff;
          transition: all 0.25s ease;
        }
        .faq-card:hover {
          border-color: #2f5bff;
          box-shadow: 0 6px 16px rgba(47, 91, 255, 0.12);
        }
        .faq-card-icon {
          font-size: 1.8rem;
          margin-bottom: 1rem;
          color: #555;
        }
        .faq-card p {
          font-weight: 700;
          font-size: 1.05rem;
          color: #000;
          margin: 0;
          line-height: 1.3;
        }
        .faq-no-result {
          text-align: center;
          color: #777;
        }
        @media (max-width: 992px) {
          .faq-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 480px) {
          .faq-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
};

export default FAQ;